import React from 'react';
import { Box, Container, Grid, Typography, Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const AboutSection: React.FC = () => {
  return (
    <Box sx={{ py: 8, backgroundColor: 'background.paper' }}>
      <Container>
        <Grid container spacing={4} alignItems="center">
          <Grid item xs={12} md={6}>
            <Typography variant="h2" component="h2" gutterBottom fontWeight={700}>
              About JBR Delivery Service
            </Typography>
            
            <Typography variant="body1" paragraph sx={{ mb: 3 }}>
              At JBR Delivery Service, our mission is to provide efficient, reliable, and eco-friendly solutions for all of your delivery, junk removal, and moving needs. We strive to simplify your life by offering professional services that are quick, affordable, and tailored to your specific needs, ensuring a smooth and stress-free experience every time.
            </Typography>
            
            <Typography variant="body1" paragraph>
              Whether you're moving into a new home, decluttering, or seeking delivery assistance, we are dedicated to helping you get things done with care, commitment, and a customer-first approach.
            </Typography>
            
            <Button
              variant="outlined"
              color="primary"
              endIcon={<ArrowForwardIcon />}
              component={RouterLink}
              to="/about"
              sx={{ mt: 2, fontWeight: 600 }}
            >
              Learn More About Us
            </Button>
          </Grid>
          
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/assets/images/about-placeholder.jpg"
              alt="JBR Delivery Service team"
              sx={{
                width: '100%',
                borderRadius: 2,
                boxShadow: 3,
                height: '400px',
                objectFit: 'cover',
              }}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default AboutSection;
